import './Img2pdf.scss';
import React, { useState, useEffect, useRef } from 'react';
import HongButton from '../comm/HongButtonNew';
import HeaderTitle from '../comm/HeaderTitle';
import { FaFilePdf, FaDownload, FaSearchPlus, FaSearchMinus, FaUndo, FaTimes, FaSync } from 'react-icons/fa';

import jsPDF from 'jspdf';
import { BsBorder } from 'react-icons/bs';
//npm install jspdf


const A4_WIDTH = 595.28; // pt
const A4_HEIGHT = 841.89; // pt
const MARGIN = 20;
const COLUMN_GAP = 10;
const COLUMN_COUNT = 2;
const COLUMN_WIDTH = (A4_WIDTH - MARGIN * 2 - COLUMN_GAP) / COLUMN_COUNT;
const PAGE_NUMBER_HEIGHT = 30; // 페이지 번호 영역
const QUESTION_NUMBER_HEIGHT = 20; // 문항 번호 영역
const COLUMN_HEIGHT = A4_HEIGHT - MARGIN * 2 - PAGE_NUMBER_HEIGHT;
const QUESTION_MARGIN = 30; // 문제 간 여백을 30pt로 수정

const Img2pdf = ({imgList, onClose, setIsModal}) => {
  const [pages, setPages] = useState([]);
  const [zoomLevel, setZoomLevel] = useState(1.5);
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [list, setList] = useState([]);
  const [pdfType, setPdfType] = useState('question'); // 'question' 또는 'solution' 또는 'both'
  const [questionMargin, setQuestionMargin] = useState(30); // 문항간격 상태 추가
  const previewContainerRef = useRef(null); // 미리보기 컨테이너 ref 추가

  // 라디오 버튼 옵션 배열
  const pdfTypeOptions = [
    { value: 'question', label: '문제' },
    { value: 'solution', label: '풀이' },
    { value: 'both', label: '문풀' }
  ];

  // 문항간격 옵션 배열
  const marginOptions = [
    { value: 50, label: '좁게' },
    { value: 100, label: '보통' },
    { value: 150, label: '넓게' },
    { value: 200, label: '매우넓게' },
    { value: 250, label: '최대' }
  ];

  useEffect(() => {
    if (!imgList || imgList.length === 0) {
      setList([]);
  
      return;
    }
    
    const newList = [];
    for (let i = 0; i < imgList.length; i++) {
      // imgList에서 imagePath가 있는지 확인
      if (imgList[i] && imgList[i].imagePath) {
        let src, src_sol, kind;
        
        src = imgList[i].imagePath; // 문제 이미지
        src_sol = imgList[i].imagePath_sol; // 풀이 이미지
        kind = imgList[i].kind;
        
        // pdfType에 따라 다른 이미지 추가
        if (pdfType === 'question') {
          // 문제만
          newList.push({src: src, kind: kind, isNo: true});
        } else if (pdfType === 'solution' && src_sol) {
          // 풀이만
          newList.push({src: src_sol, kind: kind, isNo: true});
        } else if (pdfType === 'both') {
          // 문제 + 풀이
          newList.push({src: src, kind: kind, isNo: true});
          if (src_sol) {
            newList.push({src: src_sol, kind: kind, isNo: false});
          }
        }
      }
    }
    
    setList(newList);

  }, [imgList, pdfType]);

  useEffect(() => {
    if (list.length > 0) {
      loadAndSplitImages();
    }
  }, [list, questionMargin]);


    const loadAndSplitImages = async () => {
      setIsLoading(true);
      setProgress(0);
      setLoadingMessage('문제를 로딩 중입니다...');
      
      // 미리보기 컨테이너를 맨 위로 스크롤
      if (previewContainerRef.current) {
        previewContainerRef.current.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
      
      const allQuestionParts = [];
      const totalImages = list.length; // 총 이미지 개수
      let currentQuestionNumber = 1; // 실제 문항번호
      
      for (let i = 1; i <= totalImages; i++) {
        //주석 지우지 말것
        // const num = String(i).padStart(5, '0');
        
        // const src = `/imgQue/H2000B13941_${num}.gif`;
        // const src = `/imgQue/H2000B12946_${num}.gif`;
        const src = list[i-1].src;
        const kind = list[i-1].kind;
        const isNo = list[i-1].isNo; // isNo 속성 추가

        setLoadingMessage(`문제 ${i}/${totalImages} 로딩 중...`);
        setProgress(((i - 1) / totalImages) * 50); // 로딩 단계는 50%까지

        const img = new Image();
        img.crossOrigin = 'anonymous'; // CORS 설정 추가
        img.src = src;
        await new Promise((res, rej) => {
          img.onload = res;
          img.onerror = (error) => {
            console.error('이미지 로딩 실패:', src, error);
            rej(error);
          };
        });

        // 각 문제의 조각들을 생성
        setLoadingMessage(`이미지 ${i}/${totalImages} 처리 중...`);
        const parts = await splitImageByWhitespace(img, currentQuestionNumber, kind, isNo, questionMargin);
        allQuestionParts.push(...parts);
        
        // isNo가 true인 경우에만 문항번호 증가
        if (isNo === true) {
          currentQuestionNumber++;
        }
        
        setProgress((i / totalImages) * 50); // 로딩 완료 후 진행률 업데이트
      }

      setLoadingMessage('페이지 레이아웃을 구성 중...');
      setProgress(75);

      // 순서대로 페이지와 컬럼에 배치 (왼쪽 단 우선)
      const grouped = [];
      let currentPage = { left: [], right: [] };
      let leftColumnHeight = 0;
      let rightColumnHeight = 0;
      let currentColumn = 'left'; // 현재 배치 중인 컬럼 추적
      
      for (let part of allQuestionParts) {
        // isNo가 false이면 문항번호 공간 없음
        const questionNumberSpace = (part.isFirstPart && part.isNo === true) ? QUESTION_NUMBER_HEIGHT : 0;
        const partHeight = part.height + questionNumberSpace;
        const marginHeight = part.isLastPart ? questionMargin : 10;
        const totalPartHeight = partHeight + marginHeight;
        
        let placed = false;
        
        // 현재 컬럼에 배치 시도
        if (currentColumn === 'left') {
          if (leftColumnHeight + totalPartHeight <= COLUMN_HEIGHT) {
            currentPage.left.push(part);
            leftColumnHeight += totalPartHeight;
            placed = true;
          } else {
            // 왼쪽 컬럼이 꽉 찬 경우 오른쪽 컬럼으로 전환
            currentColumn = 'right';
          }
        }
        
        // 오른쪽 컬럼에 배치 시도 (왼쪽이 꽉 차거나 이미 오른쪽이 현재 컬럼인 경우)
        if (currentColumn === 'right' && !placed) {
          if (rightColumnHeight + totalPartHeight <= COLUMN_HEIGHT) {
            currentPage.right.push(part);
            rightColumnHeight += totalPartHeight;
            placed = true;
          } else {
            // 오른쪽 컬럼도 꽉 찬 경우 다음 페이지로
            currentColumn = 'left';
          }
        }
        
        // 새 페이지 시작
        if (!placed) {
          // 현재 페이지가 비어있지 않으면 저장
          if (currentPage.left.length > 0 || currentPage.right.length > 0) {
            grouped.push(currentPage);
          }
          
          // 새 페이지 시작 - 왼쪽 컬럼부터 시작
          currentPage = { left: [part], right: [] };
          leftColumnHeight = totalPartHeight;
          rightColumnHeight = 0;
          currentColumn = 'left';
        }
      }
      
      // 마지막 페이지 추가
      if (currentPage.left.length > 0 || currentPage.right.length > 0) {
        grouped.push(currentPage);
      }

      setLoadingMessage('완료!');
      setProgress(100);
      setPages(grouped);
      
      // 로딩 완료 후 프로그래스바 숨기기
      setTimeout(() => {
        setIsLoading(false);
        setProgress(0);
        setLoadingMessage('');
      }, 500);
    };


  const handleExportPdf = async () => {
    const pdf = new jsPDF('p', 'pt', 'a4');

    for (let pageIndex = 0; pageIndex < pages.length; pageIndex++) {
      if (pageIndex !== 0) pdf.addPage();

      const columns = [pages[pageIndex].left, pages[pageIndex].right];

      for (let col = 0; col < 2; col++) {
        let x = MARGIN + col * (COLUMN_WIDTH + COLUMN_GAP);
        let currentY = MARGIN;
        
        for (let part of columns[col]) {
          const img = new Image();
          img.crossOrigin = 'anonymous'; // CORS 설정 추가
          img.src = part.src;
          await new Promise((res, rej) => {
            img.onload = res;
            img.onerror = rej;
          });

          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);

          const imgData = canvas.toDataURL('image/jpeg', 1.0);
          const ratio = COLUMN_WIDTH / img.width;
          const scaledHeight = img.height * ratio;
          
          // 문제 번호 추가 (첫 번째 파트이고 isNo가 true인 경우)
          if (part.isFirstPart && part.isNo === true) {
            pdf.setFontSize(16);
            pdf.setTextColor(60, 60, 60);
            pdf.text(`${part.questionNumber}.`, x + 4, currentY + 16);
            currentY += QUESTION_NUMBER_HEIGHT;
          }

          // 이미지 추가
          pdf.addImage(imgData, 'JPEG', x, currentY, COLUMN_WIDTH, scaledHeight);
          currentY += scaledHeight;
          
          // 여백 추가 (마지막 파트면 문제 간 여백, 아니면 일반 여백)
          if (part.isLastPart) {
            currentY += questionMargin;
          } else {
            currentY += 10;
          }
        }
      }
      
      // 페이지 번호 추가
      const pageNumStr = `- ${pageIndex + 1}/${pages.length} -`;
      pdf.setFontSize(14);
      const textWidth = pdf.getTextWidth(pageNumStr);
      pdf.text(pageNumStr, (A4_WIDTH - textWidth) / 2, A4_HEIGHT - 30);
    }

    pdf.save('output.pdf');
  };

  const handleZoomIn = () => {
    setZoomLevel(prev => Math.min(2, prev + 0.25)); // 최대 200%
  };

  const handleZoomOut = () => {
    setZoomLevel(prev => Math.max(0.5, prev - 0.25)); // 최소 50%
  };

  const handleZoomReset = () => {
    setZoomLevel(1); // 100%로 리셋
  };

  const handleRefresh = () => {
    if (list.length > 0) {
      loadAndSplitImages();
    }
  };

  //==============================================================
  return (
    <div className="Img2pdf">
            
      <article className="art-menu">

        {/* 문제/풀이/문풀 선택 라디오 버튼 */}
        <div className="pdf-type-selector">
          {pdfTypeOptions.map((option) => (
            <label key={option.value} className="radio-label">
              <input
                type="radio"
                name="pdfType"
                value={option.value}
                checked={pdfType === option.value}
                onChange={(e) => setPdfType(e.target.value)}
              />
              <span className="radio-text">{option.label}</span>
            </label>
          ))}
        </div>

        {/* 문항간격 선택 콤보박스 */}
        <div className="margin-selector">
          <label htmlFor="questionMargin" className="margin-label"></label>
          <select
            id="questionMargin"
            value={questionMargin}
            onChange={(e) => setQuestionMargin(Number(e.target.value))}
            className="margin-select"
          >
            {marginOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <HongButton 
          className='btn btn-pdf'
          onClick={handleRefresh}>
          <FaSync style={{ marginRight: '8px'}} />
          새로고침
        </HongButton>

        <HongButton 
          className='btn btn-pdf'
          onClick={handleExportPdf}>
          <FaDownload style={{ marginRight: '8px'}} />
          다운로드
        </HongButton>
        
        
        {/* 확대/축소 컨트롤 */}
        <div className="zoom-controls">
          <HongButton 
            className='btn btn-zoom'
            onClick={handleZoomOut}
            disabled={zoomLevel <= 0.5}
          >
            <FaSearchMinus />
          </HongButton>
          
          <span className="zoom-percentage">
            {Math.round(zoomLevel * 100)}%
          </span>
          
          <HongButton 
            className='btn btn-zoom'
            onClick={handleZoomIn}
            disabled={zoomLevel >= 2}
          >
            <FaSearchPlus />
          </HongButton>
          
          <HongButton 
            className='btn btn-zoom'
            onClick={handleZoomReset}
          >
            <FaUndo />
          </HongButton>

          
        </div>

        {/* 닫기 버튼 추가 */}
        <HongButton className='btn btn-close' onClick={() => setIsModal(false)}>
          <FaTimes style={{ marginRight: '5px'}} />
          닫기
        </HongButton>
      </article>

      {/* 프로그래스바 */}
      {isLoading && (
        <div className="progress-container">
          <div className="progress-card">
            <div className="progress-message">
              {loadingMessage}
            </div>
            
            <div className="progress-bar-container">
              <div 
                className="progress-bar_pdf"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            
            <div className="progress-percentage">
              {Math.round(progress)}% 완료
            </div>
          </div>
        </div>
      )}

      <div 
        ref={previewContainerRef}
        className="preview-container"
        style={{ padding: `${10 * zoomLevel}px` }}
      >
        {pages.map((page, pageIndex) => (
          <div
            key={pageIndex}
            className="preview-page"
            style={{
              gap: `${COLUMN_GAP * zoomLevel}px`,
              width: `${A4_WIDTH * zoomLevel}px`,
              height: `${A4_HEIGHT * zoomLevel}px`,
              padding: `${MARGIN * zoomLevel}px`,
              marginBottom: `${20 * zoomLevel}px`,
              borderWidth: `${1 * zoomLevel}px`,
              boxShadow: `0 ${2 * zoomLevel}px ${4 * zoomLevel}px rgba(0,0,0,0.1)`
            }}
          >
            {[page.left, page.right].map((colItems, colIdx) => (
              <div 
                key={colIdx} 
                className="column"
                style={{ 
                  width: `${COLUMN_WIDTH * zoomLevel}px`,
                  height: `${COLUMN_HEIGHT * zoomLevel}px`
                }}
              >
                {colItems.map((item, itemIdx) => (
                  <div 
                    key={itemIdx} 
                    className="question-item"
                    style={{ 
                      marginBottom: item.isLastPart ? `${questionMargin * zoomLevel}px` : `${10 * zoomLevel}px`
                    }}
                  >
                    {item.isFirstPart && item.isNo === true && (
                      <div 
                        className="question-number"
                        style={{ 
                          fontSize: `${1.2 * zoomLevel}rem`, 
                          marginBottom: `${0.3 * zoomLevel}rem`
                        }}
                      >
                        {item.questionNumber}.
                      </div>
                    )}
                    <img
                      src={item.src}
                      className="question-image"
                      alt={`문항 ${item.questionNumber}-${item.partIndex + 1}`}
                    />
                  </div>
                ))}
              </div>
            ))}

            <div 
              className="page-number"
              style={{
                bottom: `${10 * zoomLevel}px`,
                fontSize: `${14 * zoomLevel}px`
              }}
            >
              - {pageIndex + 1}/{pages.length} -
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// 이미지를 컬럼 높이에 맞춰 분할하는 함수 개선
const splitImageByColumnHeight = async (img, questionNumber, kind) => {
  try {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);

    const ratio = COLUMN_WIDTH / img.width;
    const scaledHeight = img.height * ratio;

    const maxHeightWithQuestionNumber = kind === '@'
      ? COLUMN_HEIGHT - QUESTION_MARGIN
      : COLUMN_HEIGHT - QUESTION_NUMBER_HEIGHT - QUESTION_MARGIN;
    const maxHeightWithoutQuestionNumber = COLUMN_HEIGHT - QUESTION_MARGIN;

    const parts = [];
    let currentY = 0;
    let partIndex = 0;

    if (scaledHeight <= maxHeightWithQuestionNumber) {
      parts.push({
        src: canvas.toDataURL('image/png'),
        questionNumber: questionNumber,
        partIndex: 0,
        isFirstPart: true,
        isLastPart: true,
        startY: 0,
        originalHeight: img.height,
        height: scaledHeight,
        kind: kind
      });
    } else {
      while (currentY < img.height) {
        const isFirstPart = partIndex === 0;
        const maxHeight = (isFirstPart && kind !== '@') ? maxHeightWithQuestionNumber : maxHeightWithoutQuestionNumber;
        const maxOriginalHeight = maxHeight / ratio;
        const remainingHeight = img.height - currentY;


        let partHeight;
        if (remainingHeight <= maxOriginalHeight) {
          partHeight = remainingHeight;
        } else {
          // 200px window 내에서 완전한 여백(검은색 없는 행) 우선, 없으면 white 비율 최대 행
          const scanWindow = 200;
          const scanStart = Math.max(currentY, currentY + maxOriginalHeight - scanWindow);
          const scanEnd = Math.min(img.height - 1, currentY + maxOriginalHeight);
          const imageData = ctx.getImageData(0, 0, img.width, img.height).data;
          let perfectWhiteRows = [];
          let bestY = scanEnd;
          let bestWhiteScore = -1;
          // 1. 완전한 여백(검은색 없는 행) 찾기
          for (let y = scanEnd; y >= scanStart; y--) {
            let isPerfectWhite = true;
            let whiteCount = 0;
            for (let x = 0; x < img.width; x++) {
              const idx = (y * img.width + x) * 4;
              const r = imageData[idx];
              const g = imageData[idx + 1];
              const b = imageData[idx + 2];
              const gray = (r + g + b) / 3;
              if (gray < 60) { // 더 엄격한 검은색 임계값
                isPerfectWhite = false;
              }
              if (gray > 245) whiteCount++; // 더 높은 흰색 임계값
            }
            if (isPerfectWhite) {
              perfectWhiteRows.push(y);
            }
            // 동시에 white 비율도 계산
            const whiteRatio = whiteCount / img.width;
            if (whiteRatio > bestWhiteScore) {
              bestWhiteScore = whiteRatio;
              bestY = y;
            }
          }
          let cutY = null;
          if (perfectWhiteRows.length > 0) {
            // 이상적인 cut에 가장 가까운 완전한 여백 행 선택
            const idealY = currentY + maxOriginalHeight;
            cutY = perfectWhiteRows.reduce((prev, curr) =>
              Math.abs(curr - idealY) < Math.abs(prev - idealY) ? curr : prev
            );
          } else {
            cutY = bestY;
          }
          partHeight = cutY - currentY + 1;
          // 너무 작은 조각 방지
          if (partHeight < maxOriginalHeight * 0.6) { // 최소 높이 비율 증가
            partHeight = Math.min(maxOriginalHeight * 0.8, remainingHeight);
          }
          const absoluteMinHeight = 120; // 절대 최소 높이 증가
          if (partHeight < absoluteMinHeight && remainingHeight > absoluteMinHeight) {
            partHeight = Math.min(absoluteMinHeight, remainingHeight);
          }
        }

        const partCanvas = document.createElement('canvas');
        partCanvas.width = img.width;
        partCanvas.height = partHeight;
        const partCtx = partCanvas.getContext('2d');
        partCtx.drawImage(img, 0, currentY, img.width, partHeight, 0, 0, img.width, partHeight);

        const isLastPart = (currentY + partHeight) >= img.height;

        parts.push({
          src: partCanvas.toDataURL('image/png'),
          questionNumber: questionNumber,
          partIndex: partIndex,
          isFirstPart: isFirstPart,
          isLastPart: isLastPart,
          startY: currentY,
          originalHeight: partHeight,
          height: partHeight * ratio,
          kind: kind
        });

        currentY += partHeight;
        partIndex++;
        if (isLastPart) break;
      }
    }
    return parts;
  } catch (error) {
    console.error('Canvas 처리 오류:', error);
    return [{
      src: img.src,
      questionNumber: questionNumber,
      partIndex: 0,
      isFirstPart: true,
      isLastPart: true,
      startY: 0,
      originalHeight: img.height,
      height: img.height * (COLUMN_WIDTH / img.width),
      kind: kind
    }];
  }
};

// 여백 영역을 찾는 함수
const findWhitespaceRegions = async (img) => {
  const canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0);
  const data = ctx.getImageData(0, 0, img.width, img.height).data;

  const threshold = 240;
  const whiteRatio = 0.9;
  const minBlankHeight = 10;
  
  // 중앙 60% 영역에서 여백 감지 (좌우 여백 제외)
  const startX = Math.floor(img.width * 0.2);
  const endX = Math.ceil(img.width * 0.8);
  
  // 각 행의 여백도 계산
  const rowWhitenessScores = [];
  for (let y = 0; y < img.height; y++) {
    let whiteCount = 0;
    let totalPixels = endX - startX;
    
    for (let x = startX; x < endX; x++) {
      const idx = (y * img.width + x) * 4;
      const r = data[idx], g = data[idx + 1], b = data[idx + 2];
      const gray = (r + g + b) / 3;
      if (gray > threshold) whiteCount++;
    }
    
    rowWhitenessScores.push(whiteCount / totalPixels);
  }

  // 연속된 여백 영역 찾기
  const blankRegions = [];
  let currentRegionStart = -1;
  let consecutiveBlankCount = 0;

  for (let y = 0; y < img.height; y++) {
    const isBlankRow = rowWhitenessScores[y] >= whiteRatio;
    
    if (isBlankRow) {
      if (currentRegionStart === -1) {
        currentRegionStart = y;
        consecutiveBlankCount = 1;
      } else {
        consecutiveBlankCount++;
      }
    } else {
      if (currentRegionStart !== -1 && consecutiveBlankCount >= minBlankHeight) {
        blankRegions.push({
          start: currentRegionStart,
          end: y - 1,
          center: Math.floor((currentRegionStart + y - 1) / 2),
          height: consecutiveBlankCount
        });
      }
      currentRegionStart = -1;
      consecutiveBlankCount = 0;
    }
  }

  // 마지막 영역 처리
  if (currentRegionStart !== -1 && consecutiveBlankCount >= minBlankHeight) {
    blankRegions.push({
      start: currentRegionStart,
      end: img.height - 1,
      center: Math.floor((currentRegionStart + img.height - 1) / 2),
      height: consecutiveBlankCount
    });
  }

  return blankRegions;
};

// 최적의 자르기 지점을 찾는 함수
const findBestCutPoint = (whitespaceRegions, startY, idealCutPoint, maxHeight) => {
  // 이상적인 자르기 지점 근처의 여백 찾기
  const searchRange = 50; // 50px 범위 내에서 검색
  let bestCutPoint = idealCutPoint;
  let bestScore = -1;
  
  for (const region of whitespaceRegions) {
    // 검색 범위 내에 있는 여백 영역 찾기
    if (region.center >= idealCutPoint - searchRange && 
        region.center <= idealCutPoint + searchRange &&
        region.center > startY) {
      
      // 여백의 크기와 이상적인 지점과의 거리를 고려한 점수 계산
      const distanceFromIdeal = Math.abs(region.center - idealCutPoint);
      const score = region.height - (distanceFromIdeal / 10);
      
      if (score > bestScore) {
        bestScore = score;
        bestCutPoint = region.center;
      }
    }
  }
  
  // 적절한 여백을 찾지 못한 경우 이상적인 지점 사용
  if (bestScore === -1) {
    bestCutPoint = Math.min(idealCutPoint, maxHeight);
  }
  
  return Math.min(bestCutPoint, maxHeight);
};

// 여백을 감지하여 이미지를 분할하는 함수 (개선된 버전)
const splitImageByWhitespace = async (img, questionNumber, kind, isNo = true, questionMargin = 30) => {
  try {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);

    // 컬럼 너비에 맞춘 스케일 비율 계산
    const ratio = COLUMN_WIDTH / img.width;
    const scaledHeight = img.height * ratio;
    
    // 문제 번호 공간과 문제 간 여백을 고려한 최대 높이
    const maxHeightWithQuestionNumber = (isNo === false || kind === '@' || !kind || kind.trim() === '') ? 
      COLUMN_HEIGHT - questionMargin : 
      COLUMN_HEIGHT - QUESTION_NUMBER_HEIGHT - questionMargin;
    const maxHeightWithoutQuestionNumber = COLUMN_HEIGHT - questionMargin;
    
    // 이미지가 한 컬럼에 들어갈 수 있는지 확인
    if (scaledHeight <= maxHeightWithQuestionNumber) {
      // 한 컬럼에 들어가는 경우 - 분할하지 않음
      return [{
        src: canvas.toDataURL('image/png'),
        questionNumber: questionNumber,
        partIndex: 0,
        isFirstPart: true,
        isLastPart: true,
        startY: 0,
        originalHeight: img.height,
        height: scaledHeight,
        kind: kind,
        isNo: isNo
      }];
    }

    // 여백 영역 찾기 (개선된 버전)
    const whitespaceRegions = await findOptimalWhitespaces(img);
    
    const parts = [];
    let currentY = 0;
    let partIndex = 0;
    
    while (currentY < img.height) {
      const isFirstPart = partIndex === 0;
      const maxHeight = (isFirstPart && isNo === true && kind !== '@' && kind && kind.trim() !== '') ? 
        maxHeightWithQuestionNumber : maxHeightWithoutQuestionNumber;
      
      // 스케일된 높이를 원본 이미지 높이로 변환
      const maxOriginalHeight = maxHeight / ratio;
      const remainingHeight = img.height - currentY;
      
      let partHeight;
      
      if (remainingHeight <= maxOriginalHeight) {
        // 남은 높이가 최대 높이보다 작으면 모두 포함
        partHeight = remainingHeight;
      } else {
        // 이상적인 자르기 지점 계산
        const idealCutPoint = currentY + maxOriginalHeight;
        
        // 여백 영역에서 최적의 자르기 지점 찾기
        const bestCutPoint = findOptimalCutPoint(whitespaceRegions, currentY, idealCutPoint, currentY + maxOriginalHeight);
        partHeight = bestCutPoint - currentY;
        
        // 최소 높이 보장을 더욱 보수적으로 수정 (완전한 여백 우선)
        if (partHeight < maxOriginalHeight * 0.6) { // 60%로 더 보수적으로
          partHeight = Math.min(maxOriginalHeight * 0.8, remainingHeight); // 80%까지만 사용
        }
        
        // 추가 안전장치: 매우 작은 조각 방지
        if (partHeight < maxOriginalHeight * 0.5) {
          partHeight = Math.min(maxOriginalHeight * 0.7, remainingHeight); // 70%로 제한
        }
        
        // 최종 안전장치: 절대 최소 크기 보장
        const absoluteMinHeight = 100; // 최소 100px 보장
        if (partHeight < absoluteMinHeight && remainingHeight > absoluteMinHeight) {
          partHeight = Math.min(absoluteMinHeight, remainingHeight);
        }
      }
      
      // 이미지 조각 생성
      const partCanvas = document.createElement('canvas');
      partCanvas.width = img.width;
      partCanvas.height = partHeight;
      const partCtx = partCanvas.getContext('2d');
      partCtx.drawImage(img, 0, currentY, img.width, partHeight, 0, 0, img.width, partHeight);
      
      const isLastPart = (currentY + partHeight) >= img.height;
      
      parts.push({
        src: partCanvas.toDataURL('image/png'),
        questionNumber: questionNumber,
        partIndex: partIndex,
        isFirstPart: isFirstPart,
        isLastPart: isLastPart,
        startY: currentY,
        originalHeight: partHeight,
        height: partHeight * ratio,
        kind: kind,
        isNo: isNo
      });
      
      currentY += partHeight;
      partIndex++;
      
      if (isLastPart) break;
    }
    
    return parts;
  } catch (error) {
    console.error('여백 감지 처리 오류:', error);
    // 오류 발생 시 기존 방식으로 분할
    return await splitImageByColumnHeight(img, questionNumber, kind, isNo);
  }
};

// 최적의 여백 영역을 찾는 함수 (검은색 없는 완전한 여백 감지)
const findOptimalWhitespaces = async (img) => {
  const canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0);
  const data = ctx.getImageData(0, 0, img.width, img.height).data;

  // 완전한 여백 감지를 위한 엄격한 파라미터
  const whiteThreshold = 240; // 흰색 임계값
  const darkThreshold = 80;   // 검은색/어두운 색 임계값
  const strictWhiteRatio = 100; // 98% 이상이 흰색이어야 함
  const noDarkRatio = 1.0;    // 검은색이 전혀 없어야 함 (100%)
  const minBlankHeight = 12;  // 최소 여백 높이를 늘림
  
  // 가운데 98% 영역에서 여백 감지 (텍스트 영역 확실히 포함)
  const startX = Math.floor(img.width * 0.01);
  const endX = Math.ceil(img.width * 0.99);
  
  // 다중 스캔: 여러 영역에서 검은색 없는 여백 감지
  const scanRegions = [
    { start: 0.05, end: 0.95, weight: 2.0 }, // 중앙 90% - 높은 가중치
    { start: 0.02, end: 0.98, weight: 1.5 }, // 중앙 96%
    { start: 0.01, end: 0.99, weight: 1.0 }  // 중앙 98%
  ];
  
  const allBlankRegions = [];
  
  // 각 스캔 영역에서 완전한 여백 찾기
  for (const region of scanRegions) {
    const regionStartX = Math.floor(img.width * region.start);
    const regionEndX = Math.ceil(img.width * region.end);
    
    // 각 행의 색상 분석 (검은색 완전 배제)
    const rowAnalysis = [];
    for (let y = 0; y < img.height; y++) {
      let whiteCount = 0;
      let darkCount = 0;
      let totalPixels = regionEndX - regionStartX;
      let brightestPixel = 0;
      let darkestPixel = 255;
      
      for (let x = regionStartX; x < regionEndX; x++) {
        const idx = (y * img.width + x) * 4;
        const r = data[idx], g = data[idx + 1], b = data[idx + 2];
        const gray = (r + g + b) / 3;
        
        // 밝기 통계
        brightestPixel = Math.max(brightestPixel, gray);
        darkestPixel = Math.min(darkestPixel, gray);
        
        if (gray > whiteThreshold) whiteCount++;
        if (gray < darkThreshold) darkCount++;
      }
      
      const whiteness = whiteCount / totalPixels;
      const darkness = darkCount / totalPixels;
      const brightness = (brightestPixel + (255 - darkestPixel)) / 2; // 전체적인 밝기
      
      rowAnalysis.push({ 
        whiteness, 
        darkness, 
        brightness,
        hasDark: darkness > 0,
        isAlmostWhite: whiteness >= strictWhiteRatio && darkness === 0
      });
    }

    // 완전한 여백 영역 찾기 (검은색이 전혀 없는 영역)
    let currentRegionStart = -1;
    let consecutiveBlankCount = 0;

    for (let y = 0; y < img.height; y++) {
      const analysis = rowAnalysis[y];
      // 매우 엄격한 조건: 98% 이상 흰색 + 검은색 0% + 전체적으로 밝음
      const isPerfectBlank = analysis.isAlmostWhite && 
                           analysis.brightness > 200 &&
                           !analysis.hasDark;
      
      if (isPerfectBlank) {
        if (currentRegionStart === -1) {
          currentRegionStart = y;
          consecutiveBlankCount = 1;
        } else {
          consecutiveBlankCount++;
        }
      } else {
        if (currentRegionStart !== -1 && consecutiveBlankCount >= minBlankHeight) {
          allBlankRegions.push({
            start: currentRegionStart,
            end: y - 1,
            center: Math.floor((currentRegionStart + y - 1) / 2),
            height: consecutiveBlankCount,
            type: 'perfect',
            weight: region.weight,
            score: consecutiveBlankCount * 5 * region.weight, // 완전한 여백에 매우 높은 점수
            purity: 1.0 // 완전한 순도
          });
        }
        currentRegionStart = -1;
        consecutiveBlankCount = 0;
      }
    }

    // 마지막 완전한 여백 영역 처리
    if (currentRegionStart !== -1 && consecutiveBlankCount >= minBlankHeight) {
      allBlankRegions.push({
        start: currentRegionStart,
        end: img.height - 1,
        center: Math.floor((currentRegionStart + img.height - 1) / 2),
        height: consecutiveBlankCount,
        type: 'perfect',
        weight: region.weight,
        score: consecutiveBlankCount * 5 * region.weight,
        purity: 1.0
      });
    }

    // 보조적으로 거의 완전한 여백도 찾기 (fallback용)
    currentRegionStart = -1;
    consecutiveBlankCount = 0;

    for (let y = 0; y < img.height; y++) {
      const analysis = rowAnalysis[y];
      // 조금 더 관대한 조건: 95% 이상 흰색 + 검은색 매우 적음
      const isNearPerfectBlank = analysis.whiteness >= 0.95 && 
                                analysis.darkness <= 0.01 &&
                                analysis.brightness > 180;
      
      if (isNearPerfectBlank) {
        if (currentRegionStart === -1) {
          currentRegionStart = y;
          consecutiveBlankCount = 1;
        } else {
          consecutiveBlankCount++;
        }
      } else {
        if (currentRegionStart !== -1 && consecutiveBlankCount >= minBlankHeight * 1.5) { // 더 긴 영역만
          // 완전한 여백과 겹치지 않는 경우에만 추가
          const hasPerf부처Overlap = allBlankRegions.some(existing => 
            existing.type === 'perfect' && 
            Math.abs(existing.center - Math.floor((currentRegionStart + y - 1) / 2)) < 30
          );
          
          if (!hasPerf부처Overlap) {
            allBlankRegions.push({
              start: currentRegionStart,
              end: y - 1,
              center: Math.floor((currentRegionStart + y - 1) / 2),
              height: consecutiveBlankCount,
              type: 'near-perfect',
              weight: region.weight * 0.7, // 낮은 가중치
              score: consecutiveBlankCount * 2 * region.weight * 0.7,
              purity: 0.8
            });
          }
        }
        currentRegionStart = -1;
        consecutiveBlankCount = 0;
      }
    }

    // 마지막 거의 완전한 여백 영역 처리
    if (currentRegionStart !== -1 && consecutiveBlankCount >= minBlankHeight * 1.5) {
      const hasPerf부처Overlap = allBlankRegions.some(existing => 
        existing.type === 'perfect' && 
        Math.abs(existing.center - Math.floor((currentRegionStart + img.height - 1) / 2)) < 30
      );
      
      if (!hasPerf부처Overlap) {
        allBlankRegions.push({
          start: currentRegionStart,
          end: img.height - 1,
          center: Math.floor((currentRegionStart + img.height - 1) / 2),
          height: consecutiveBlankCount,
          type: 'near-perfect',
          weight: region.weight * 0.7,
          score: consecutiveBlankCount * 2 * region.weight * 0.7,
          purity: 0.8
        });
      }
    }
  }

  // 중복 제거 및 품질 기준 정렬
  const uniqueRegions = [];
  allBlankRegions.forEach(region => {
    const isDuplicate = uniqueRegions.some(existing => 
      Math.abs(existing.center - region.center) < 15
    );
    
    if (!isDuplicate) {
      uniqueRegions.push(region);
    } else {
      // 중복된 경우 더 높은 점수와 순도의 영역 유지
      const existingIndex = uniqueRegions.findIndex(existing => 
        Math.abs(existing.center - region.center) < 15
      );
      const existing = uniqueRegions[existingIndex];
      
      if (region.score > existing.score || 
          (region.score === existing.score && region.purity > existing.purity)) {
        uniqueRegions[existingIndex] = region;
      }
    }
  });

  // 점수와 순도 기준으로 정렬 (완전한 여백 우선)
  return uniqueRegions.sort((a, b) => {
    if (a.type === 'perfect' && b.type !== 'perfect') return -1;
    if (b.type === 'perfect' && a.type !== 'perfect') return 1;
    return b.score - a.score;
  });
};

// 최적의 자르기 지점을 찾는 함수 (완전한 여백 우선)
const findOptimalCutPoint = (whitespaceRegions, startY, idealCutPoint, maxCutPoint) => {
  if (whitespaceRegions.length === 0) {
    return Math.min(idealCutPoint, maxCutPoint);
  }

  let bestCutPoint = idealCutPoint;
  let bestScore = -1;
  
  // 매우 보수적인 검색 범위
  const searchRange = 100; 
  const safetyMargin = 40; // 더 큰 안전 여백
  
  // 1단계: 완전한 여백(검은색 없음) 우선 검색
  for (const region of whitespaceRegions) {
    if (region.type === 'perfect' && 
        region.center >= startY + safetyMargin && 
        region.center <= idealCutPoint + searchRange) {
      
      const distanceFromIdeal = Math.abs(region.center - idealCutPoint);
      
      // 완전한 여백에 대한 점수 계산 (매우 높은 우선순위)
      let score = region.score * 3; // 완전한 여백에 최고 가중치
      
      // 이상적인 지점 근처에 있으면 추가 보너스
      if (distanceFromIdeal <= 50) {
        score += (50 - distanceFromIdeal) * 2.0;
      }
      
      // 충분히 큰 완전한 여백에 대한 보너스
      if (region.height >= 15) {
        score += region.height * 1.5;
      }
      
      // 텍스트 영역에서 충분히 떨어진 경우 보너스
      if (region.center - startY >= 60) {
        score += 40;
      }
      
      // 완전한 순도에 대한 보너스
      score += region.purity * 50;
      
      if (score > bestScore && region.center <= maxCutPoint - 20) { // 충분한 여유 공간
        bestScore = score;
        bestCutPoint = region.center;
      }
    }
  }
  
  // 2단계: 완전한 여백이 없으면 거의 완전한 여백 검색
  if (bestScore === -1) {
    for (const region of whitespaceRegions) {
      if (region.type === 'near-perfect' && 
          region.center >= startY + safetyMargin * 1.5 && 
          region.center <= idealCutPoint + searchRange * 0.7) {
        
        const distanceFromIdeal = Math.abs(region.center - idealCutPoint);
        
        // 거의 완전한 여백에 대한 점수 계산
        let score = region.score * 1.5;
        
        // 이상적인 지점에 가까우면 보너스
        if (distanceFromIdeal <= 40) {
          score += (40 - distanceFromIdeal) * 0.8;
        }
        
        // 큰 여백에 보너스
        if (region.height >= 20) {
          score += region.height * 0.8;
        }
        
        // 시작점에서 충분히 떨어진 경우 보너스
        if (region.center - startY >= 80) {
          score += 25;
        }
        
        // 순도에 따른 보너스
        score += region.purity * 30;
        
        if (score > bestScore && region.center <= maxCutPoint - 25) { // 더 큰 여유 공간
          bestScore = score;
          bestCutPoint = region.center;
        }
      }
    }
  }
  
  // 3단계: 여전히 찾지 못한 경우, 안전한 거리의 아무 여백이라도
  if (bestScore === -1) {
    for (const region of whitespaceRegions) {
      if (region.center > startY + safetyMargin * 2 && // 매우 큰 안전 여백
          region.center <= maxCutPoint - 30) {
        
        const distance = Math.abs(region.center - idealCutPoint);
        const safetyFactor = (region.center - startY) / 150; // 시작점에서 멀수록 안전
        
        const score = region.height * 0.3 + 
                     safetyFactor * 15 - 
                     (distance * 0.03) + 
                     region.purity * 20;
        
        if (score > bestScore) {
          bestScore = score;
          bestCutPoint = region.center;
        }
      }
    }
  }
  
  // 4단계: 최후의 수단 - 매우 보수적으로 자르기
  if (bestScore === -1) {
    // 이상적인 지점의 70% 지점에서 자르기 (매우 보수적)
    bestCutPoint = Math.min(
      startY + (idealCutPoint - startY) * 0.7, 
      maxCutPoint - 40 // 매우 큰 여유 공간 확보
    );
  }
  
  // 최종 안전성 검사
  const finalCutPoint = Math.min(bestCutPoint, maxCutPoint - 20);
  
  // 너무 작은 조각이 되지 않도록 최소 크기 보장
  const minPartHeight = (maxCutPoint - startY) * 0.4; // 40%로 증가
  if (finalCutPoint - startY < minPartHeight) {
    return Math.min(startY + minPartHeight, maxCutPoint - 20);
  }
  
  return finalCutPoint;
};

// 이미지 조각들을 하나로 결합하는 함수
const combineImageParts = async (parts) => {
  if (parts.length === 1) {
    return parts[0].src;
  }

  // 모든 이미지 로드
  const images = await Promise.all(
    parts.map(part => {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.src = part.src;
      });
    })
  );

  // 전체 높이 계산 (조각들 간 여백 포함)
  const gap = 10; // 조각 간 여백
  const totalHeight = images.reduce((sum, img) => sum + img.height, 0) + (gap * (images.length - 1));
  const maxWidth = Math.max(...images.map(img => img.width));

  // 결합된 이미지 생성
  const canvas = document.createElement('canvas');
  canvas.width = maxWidth;
  canvas.height = totalHeight;
  const ctx = canvas.getContext('2d');

  // 각 조각을 세로로 연결
  let currentY = 0;
  images.forEach((img, index) => {
    ctx.drawImage(img, 0, currentY);
    currentY += img.height + gap;
  });

  return canvas.toDataURL('image/png');
};

export default Img2pdf;
